import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@tanstack/react-router";
import { FileText, Home, MessageSquare, Package, Search } from "lucide-react";

export function NotFoundPage() {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-background px-4 py-24">
      {/* Large 404 in background */}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden">
        <span className="select-none font-black text-[200px] text-foreground opacity-5 sm:text-[300px]">
          404
        </span>
      </div>

      {/* Content */}
      <div className="container relative z-10 mx-auto max-w-4xl">
        <div className="mb-12 text-center">
          {/* Icon */}
          <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-primary/10">
            <Search className="h-12 w-12 text-primary" />
          </div>

          {/* Title */}
          <h1 className="mb-4 font-bold text-4xl tracking-tight sm:text-5xl">
            Sayfa Bulunamadı
          </h1>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Aradığınız sayfa mevcut değil, taşınmış veya silinmiş olabilir.
          </p>
        </div>

        {/* Suggested Links */}
        <div className="mb-8">
          <p className="mb-6 text-center font-medium text-muted-foreground">
            Belki bunlardan biri aradığınız şey olabilir?
          </p>

          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {/* Home */}
            <Link to="/">
              <Card className="group transition-all duration-200 hover:scale-[1.02] hover:border-primary/50 hover:shadow-lg">
                <CardHeader className="pb-3">
                  <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 transition-colors group-hover:bg-primary/20">
                    <Home className="h-6 w-6 text-primary" />
                  </div>
                  <CardTitle className="text-base">Ana Sayfa</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground text-sm">
                    Başlangıç sayfasına dön
                  </p>
                </CardContent>
              </Card>
            </Link>

            {/* Forum */}
            <Link to="/forum">
              <Card className="group transition-all duration-200 hover:scale-[1.02] hover:border-primary/50 hover:shadow-lg">
                <CardHeader className="pb-3">
                  <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 transition-colors group-hover:bg-primary/20">
                    <MessageSquare className="h-6 w-6 text-primary" />
                  </div>
                  <CardTitle className="text-base">Forum</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground text-sm">
                    Topluluk tartışmaları
                  </p>
                </CardContent>
              </Card>
            </Link>

            {/* Essays */}
            <Link to="/essay">
              <Card className="group transition-all duration-200 hover:scale-[1.02] hover:border-primary/50 hover:shadow-lg">
                <CardHeader className="pb-3">
                  <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 transition-colors group-hover:bg-primary/20">
                    <FileText className="h-6 w-6 text-primary" />
                  </div>
                  <CardTitle className="text-base">Essay'ler</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground text-sm">
                    İçerikler ve hesaplayıcılar
                  </p>
                </CardContent>
              </Card>
            </Link>

            {/* Coaching */}
            <Link to="/coachs">
              <Card className="group transition-all duration-200 hover:scale-[1.02] hover:border-primary/50 hover:shadow-lg">
                <CardHeader className="pb-3">
                  <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 transition-colors group-hover:bg-primary/20">
                    <Package className="h-6 w-6 text-primary" />
                  </div>
                  <CardTitle className="text-base">Koçluk</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground text-sm">
                    Paketler ve hizmetler
                  </p>
                </CardContent>
              </Card>
            </Link>
          </div>
        </div>

        {/* Back Button */}
        <div className="text-center">
          <Button
            variant="outline"
            size="lg"
            onClick={() => window.history.back()}
          >
            Geri Dön
          </Button>
        </div>
      </div>
    </div>
  );
}
